import React, { useState } from 'react';
import { HiOutlineEye as Visibility, HiOutlineEyeOff as VisibilityOff } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';
import { HiOutlineEye, HiOutlineEyeOff } from 'react-icons/hi';
import { post, put } from '../../utility/fetch';
import notification from '../../utility/notification';
import { requestForToken } from '../../utility/firebase.js';
import axios from 'axios';

const SignIn = () => {
    const [view, setView] = useState('login');
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [userEmail, setUserEmail] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };



    const getModules = async (clinicId, userId) => {
        const token = sessionStorage.getItem('token');
        if (!token) {
            notification({ message: 'Token not found', type: "error" });
            return;
        }

        const options = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };

        try {
            const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/medicalmodulerole/api/ModulesDetails/GetModulestandalone/GetModulestandalone?clinicid=${clinicId}&userid=${userId}`, options);
            if (res?.data?.code === 1) {
                const moduleData = Array.isArray(res?.data?.data) ? res.data?.data : [];
                sessionStorage.setItem('moduleList', JSON.stringify(moduleData));
                // navigate('/patients');
            }
        } catch (error) {
            console.error("Error fetching available modules:", error);
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const res = await post('/Auth/login/', formData);
            // const res = await axios.post('https://api.greenzonetechnologies.com.ng/connectedhealthlabapi/api/auth/auth?AuthToken=569a92605a1a4457b10673d9736daa9f85df3f1b08024ae29bbe6d9186aa5d0c')
            console.log(res)
            if (res) {
                sessionStorage.setItem('token', res?.data?.token);
                sessionStorage.setItem('healthCareProviderId', res?.data?.healthCareProvider?.id);
                sessionStorage.setItem('healthCareProviderName', res?.data?.healthCareProvider?.name);
                sessionStorage.setItem('userId', res?.data?.userId);
                localStorage.setItem('firstName', res?.data?.firstName);
                localStorage.setItem('USER_INFO', JSON.stringify(res));
                sessionStorage.setItem('lastName', res?.data?.lastName);
             
                sessionStorage.setItem('homeLink', res?.data?.homeLink);
                sessionStorage.setItem('role', res?.data?.roles[0]?.name || "");
                sessionStorage.setItem('roles', JSON.stringify(res?.data?.roles));

                // sessionStorage.setItem('token', res?.data?.data?.token);
                // sessionStorage.setItem('healthCareProviderId', res?.data?.data?.healthCareProvider?.id);
                // sessionStorage.setItem('healthCareProviderName', res?.data?.data?.healthCareProvider?.name);
                // sessionStorage.setItem('userId', res?.data?.data?.userId);
                // localStorage.setItem('firstName', res?.data?.data?.firstName);
                // localStorage.setItem('USER_INFO', JSON.stringify(res));
                // sessionStorage.setItem('lastName', res?.data?.data?.lastName);
                // sessionStorage.setItem('homeLink', res?.data?.data?.homeLink);

                // sessionStorage.setItem('role', res?.data?.data?.roles[0]?.name || "");
                // sessionStorage.setItem('roles', JSON.stringify(res?.data?.data?.roles));

                await getModules(res?.data?.healthCareProvider.id, res?.data?.userId)

                // Request Firebase device token
                try {
                    console.log("Requesting Firebase device token...");
                    const deviceToken = await requestForToken();
                    if (deviceToken) {
                        console.log("Device token obtained:", deviceToken);
                        // Send device token to the backend
                        await post("/Auth/update-device-token", {
                            userId: res.data.userId,
                            deviceToken: deviceToken,
                        });
                       
                        console.log("Device token sent successfully");
                    } else {
                        console.warn("No device token available");
                    }
                } catch (error) {
                    console.error("Failed to send device token:", error);
                }

                navigate('/dashboard');
            }
        } catch (error) {
            notification({
                title: 'ACCESS DENIED',
                message: 'Invalid credentials or access denied. Please try again.',
                type: 'error'
            });
        } finally {
            setLoading(false);
        }
    };

    const handleForgotPassword = async () => {
        if (!/\S+@\S+\.\S+/.test(userEmail)) {
            notification({ title: 'Error', message: 'Please enter a valid email address', type: 'danger' });
            return;
        }

        try {
            const res = await post(`/auth/forget-password/${userEmail}`);
            if (res) {
                notification({ title: 'Success', message: 'Password reset link sent to your email.', type: 'success' });
                setView('password');
            }
        } catch (error) {
            notification({ title: 'Error', message: 'Failed to send reset link. Please try again.', type: 'danger' });
        }
    };

    const handleResetPassword = async () => {
        if (newPassword !== confirmNewPassword) {
            notification({ title: 'Error', message: 'Passwords do not match.', type: 'danger' });
            return;
        }

        try {
            const res = await put(`/user/change-user-password/${userEmail}`, { password: newPassword });
            if (res) {
                notification({ title: 'Success', message: 'Password changed successfully.', type: 'success' });
                setView('login');
            }
        } catch (error) {
            notification({ title: 'Error', message: 'Failed to reset password. Please try again.', type: 'danger' });
        }
    };

    return (
        <div className="signin-container">
            {view === 'login' && (
                <div className="signin-left">
                    <div className="signin-content">
                        <div className="logo-section">
                            <div className="logo">
                                <div className="logo-name">
                                    <img
                                        src="Group-2.png"
                                        alt="GreenZone Medicals Logo"
                                        className="logo-image"
                                        style={{ width: '300px', height: '120px' }}
                                    />
                                    <h1>LABORATORY</h1>
                                    {/* <p>MEDICALS</p> */}
                                </div>
                            </div>
                        </div>

                        <form onSubmit={handleSubmit} className="signin-form">
                            <div className="input-group">
                                <input
                                    type="text"
                                    name="email"
                                    placeholder="Email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    className="form-input"
                                />
                            </div>

                            <div className="input-group">
                                <div className="password-wrapper">
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        name="password"
                                        placeholder="Password"
                                        value={formData.password}
                                        onChange={handleInputChange}
                                        className="form-input password-input"
                                    />
                                    <button
                                        type="button"
                                        className="password-toggle"
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                    </button>
                                </div>
                            </div>

                            <button type="submit" className="submit-btn" disabled={loading}>
                                {loading ? 'Logging in...' : 'Submit'}
                            </button>

                            <div className="form-footer">
                                <span className="forgot-password" onClick={() => setView('forgot')}>
                                    Forgot Password?
                                </span>
                                <span className="create-account" onClick={() => navigate('/sign-up')}>
                                    Create Account
                                </span>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {view === 'forgot' && (
                <div className="signin-left">
                    <div className="signin-content">
                        <h3>Forgot Password</h3>
                        <p>Please enter your email to reset your password.</p>
                        <div className="input-group">
                            <input
                                type="email"
                                name="userEmail"
                                placeholder="Email"
                                value={userEmail}
                                onChange={(e) => setUserEmail(e.target.value)}
                                className="form-input"
                            />
                        </div>
                        <button onClick={handleForgotPassword} className="submit-btn" disabled={loading}>
                            {loading ? 'Sending...' : 'Submit'}
                        </button>
                        <div className="form-footer">
                            <span className="back-to-login" onClick={() => setView('login')}>
                                Back to Login
                            </span>
                        </div>
                    </div>
                </div>
            )}

            {view === 'password' && (
                <div className="signin-left">
                    <div className="signin-content">
                        <h3>Reset Password</h3>
                        <p>Please enter your new password.</p>
                        <div className="input-group">
                            <input
                                type={showNewPassword ? 'text' : 'password'}
                                name="newPassword"
                                placeholder="New Password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                className="form-input"
                            />
                            <button
                                type="button"
                                className="password-toggle"
                                onClick={() => setShowNewPassword(!showNewPassword)}
                            >
                                {showNewPassword ? <HiOutlineEyeOff /> : <HiOutlineEye />}
                            </button>
                        </div>
                        <div className="input-group">
                            <input
                                type={showConfirmPassword ? 'text' : 'password'}
                                name="confirmNewPassword"
                                placeholder="Confirm Password"
                                value={confirmNewPassword}
                                onChange={(e) => setConfirmNewPassword(e.target.value)}
                                className="form-input"
                            />
                            <button
                                type="button"
                                className="password-toggle"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            >
                                {showConfirmPassword ? <HiOutlineEyeOff /> : <HiOutlineEye />}
                            </button>
                        </div>
                        <button
                            onClick={handleResetPassword}
                            className="submit-btn"
                            disabled={loading || newPassword !== confirmNewPassword}
                        >
                            {loading ? 'Resetting...' : 'Submit'}
                        </button>
                        <div className="form-footer">
                            <span className="back-to-login" onClick={() => setView('login')}>
                                Back to Login
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <div style={{ color: "red" }}>
            </div>
            <div className="signin-right">
                <div className="image-container">
                    <img
                        src="signin.png"
                        alt="Pharmacist in professional setting"
                        className="hero-image"
                    />
                    <div className="image-overlay">
                        <div className="stats-badge">
                            <span className="stat-number">1299</span>
                            <span className="stat-label">866</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignIn;